import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import MiddleModal from '@/components/MiddleModal';
import { AFFILIATE_MODAL_IMG } from '@/utils/configs/static.config';
import { formatPriceThousands } from '@/utils/configs/price.config';
import { getName } from '@/utils';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
import styles from './index.module.less';

const giftConfig = {
  102: {
    cover: AFFILIATE_MODAL_IMG.proBattery,
  },
  103: {
    cover: AFFILIATE_MODAL_IMG.charginStation,
  },
  411: {
    cover: AFFILIATE_MODAL_IMG.invisibleSelfieStick,
    name: {
      zh_cn: '自拍杆',
      zh_tw: '自拍杆',
      en_us: 'Selfie Stick',
      de_de: 'Selfie-Stick',
      ja_jp: '自撮り棒',
      ko_kr: '셀피스틱',
      fr_fr: 'Perche à selfie',
      es_es: 'Selfie Stick',
      it_it: 'Selfie Stick',
    },
  },
  979: {
    cover: AFFILIATE_MODAL_IMG.ONERBattrry,
    name: {
      zh_cn: '锂电池',
      zh_tw: '鋰電池',
      en_us: 'Battery Base',
      de_de: 'Akku-Basis',
      ja_jp: 'バッテリーベース',
      ko_kr: '배터리 베이스',
      fr_fr: 'Batterie',
      es_es: 'Batería',
      it_it: 'Base Batteria',
    },
  },
  881: {
    cover: AFFILIATE_MODAL_IMG.lensCap,
  },
  404: {
    cover: AFFILIATE_MODAL_IMG.coldWeatherBattery,
  },
  1171: {
    name: {
      zh_cn: '隐形自拍桿',
      zh_tw: '隱形自拍桿',
      en_us: 'Invisible Selfie Stick',
      de_de: 'Unsichtbarer Selfie-Stick',
      ja_jp: '自撮り棒',
      ko_kr: '인비저블 셀피스틱',
      fr_fr: 'Perche à Selfie Invisible',
      es_es: 'Selfie Stick Invisible para',
      it_it: 'Selfie Stick Invisibile per la',
    },
  },
  1158: {
    name: {
      zh_cn: '粘贴式镜头保护镜',
      zh_tw: '黏貼式鏡頭保護鏡',
      en_us: 'Sticky Lens Guards',
      de_de: 'Klebbarer Linsenschutz',
      ja_jp: '粘着式レンズ保護フィルター',
      ko_kr: '탈착식 렌즈 가더',
      fr_fr: 'Protèges-objectifs collants',
      es_es: 'Protector de Lentes Adhesivo',
      it_it: 'Protezioni per lenti adesive',
    },
  },
};

/**
 * 默认赠品的分销弹窗，只有在链接中存在insrc的分销链接可见
 */
@inject('app', 'area', 'product')
@observer
class Index extends Component {
  state = {
    visible: false,
  };

  onShow = () => {
    const {
      country: { code },
    } = this.props.area;
    const {
      resellerGiftsList = [],
      productDetail: { id: pid },
      curSelectCommodityId: cid,
    } = this.props.product;
    const redirectData = ThirdPartyPlatformConfig.getRedirectData({ pid, cid });
    if (redirectData?.text) return;
    if (code === 'CN') return;
    if (resellerGiftsList.length <= 0) return;
    this.setState({ visible: true });
  };

  onHide = () => {
    this.setState({ visible: false });
    document.body.removeAttribute('data-HideCustomerService');
  };

  // 弹窗标题
  GiftsTextNode = () => {
    const { LANG } = this.props.area;
    const {
      productDetail: { id: pid },
    } = this.props.product;
    const giftsTextConfig = {
      6: {
        product: 'pro2',
        txt: LANG['product.page.affiliateModal.giftsPro2'],
      },
      7: {
        product: 'onex',
        txt: LANG['product.page.affiliateModal.giftsOneX'],
      },
      10: {
        product: 'titan',
        txt: LANG['product.page.affiliateModal.giftsTitan'],
      },
      12: {
        product: 'oner',
        txt: LANG['product.page.affiliateModal.giftsOneR'],
      },
      13: {
        product: 'one_x2',
        txt: LANG['product.page.affiliateModal.giftsOneX2'],
      },
      14: {
        product: 'go-2',
        txt: LANG['product.page.affiliateModal.giftsGO2'],
      },
      21: {
        product: 'onex_real_estate_kit',
        txt: 'a Battery and a carry case added to your basket, totally free with your camera purchase.', // INRBILM,
      },
    };

    if (!giftsTextConfig[pid] || !giftsTextConfig[pid]['txt']) return null;
    return (
      <div className={styles.labelWrap}>
        <p>{LANG['product.page.affiliateModal.label']}</p>
        <p dangerouslySetInnerHTML={{ __html: giftsTextConfig[pid]['txt'] }} />
      </div>
    );
  };

  // 弹窗分销赠品
  GiftsNode = () => {
    const {
      LANG,
      country,
      country: { X_Language },
    } = this.props.area;
    const { resellerGiftsList, productDetail } = this.props.product;
    let standardGift = [];
    if (productDetail.id === 12) {
      standardGift = [411, 979];
    }
    if (productDetail.id === 13) {
      standardGift = [1158, 411];
    }
    if (productDetail.id === 14) {
      standardGift = [1331];
    }
    if (resellerGiftsList.length !== standardGift.length) return null;
    if (resellerGiftsList.filter((o) => standardGift.includes(o.commodityId)).length !== standardGift.length)
      return null;
    return (
      <div className={styles.productWrap}>
        {[12, 13].includes(productDetail.id) && <span className={styles.or}>{LANG['common.label.or']}</span>}
        {resellerGiftsList.map((o) => {
          const { commodityId: id, commodityName, displayUrl, price } = o;
          let name = getName(commodityName, 'split');
          let cover = displayUrl;
          if (giftConfig[id] && giftConfig[id]['name']) {
            name = giftConfig[id]['name'][X_Language] || giftConfig[id]['name']['en_us'];
          }
          if (giftConfig[id] && giftConfig[id]['cover']) {
            cover = giftConfig[id]['cover'];
          }
          return (
            <div className={styles.item} key={id}>
              <div className={styles.cover} style={{ backgroundImage: `url('${cover}')` }} />
              <p className={styles.name}>{name}</p>
              <p className={styles.price}>
                {formatPriceThousands({
                  price: 0,
                  country,
                })}
              </p>
              <p className={styles.originPrice}>
                {formatPriceThousands({
                  price: price?.amount,
                  country,
                })}
              </p>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const {
      LANG,
      country: { X_Language },
    } = this.props.area;
    const {
      productDetail: { id: pid },
      curSelectCommodityId: cid,
    } = this.props.product;
    const { insrc } = this.props.app;
    const GiftsTextNode = this.GiftsTextNode();
    const GiftsNode = this.GiftsNode();
    if (!GiftsNode) return null;
    if (!GiftsTextNode) return null;
    if (['INRT6D4', 'INR9AIJ', 'INRI2DX', 'INR6XUJ', 'INRDWQL', 'INR8V3C', 'INRETXT'].includes(insrc) && pid === 12)
      return null;
    if (['INR3GYV'].includes(insrc) && pid === 13) return null;
    if (['INRRMKQ'].includes(insrc) && pid === 21) return null;
    if (['KROFFICIAL'].includes(insrc)) return null;
    if (!this.state.visible) return null;
    let hideText = false;
    if (['INRM1IZ'].includes(insrc) && pid === 21) {
      hideText = true;
    }
    return (
      <MiddleModal
        visible
        width={590}
        onCancel={this.onHide}
        theme='float'
        closable={false}
        wrapClassName={styles.AffiliateModal}
      >
        <div className={styles.wrapper}>
          <img className={styles.bg} src={AFFILIATE_MODAL_IMG.bg} alt='' />
          <button className={styles.btnClose} onClick={this.onHide}>
            ×
          </button>
          <div className={styles.container}>
            <div className={styles.titleWrap} data-l={X_Language}>
              <p className={styles.t1}>{LANG['product.page.affiliateModal.title']}</p>
              <p className={styles.t2}>{LANG['product.page.affiliateModal.subTitle']}</p>
            </div>
            {!hideText && GiftsTextNode}
            {GiftsNode}
            <p className={styles.tips}>{LANG['product.reseller.giftTips']}</p>
          </div>
        </div>
      </MiddleModal>
    );
  }
}

export default Index;
